import React from "react";

import { StatusOnlineIcon } from "@heroicons/react/outline";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Text,
  Title,
  Badge,
} from "@tremor/react";

const Defendants = ({ data }) => {
  return (
    <Card className="mt-3">
      <Title>Εναγόμενοι</Title>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Αυξ. Αριθμός</TableHeaderCell>
            <TableHeaderCell>Κατηγορία</TableHeaderCell>
            <TableHeaderCell>Επώνυμο</TableHeaderCell>
            <TableHeaderCell>Όνομα</TableHeaderCell>
            <TableHeaderCell>Πατρώνυμο</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => (
            <TableRow key={`a-${i}`}>
              <TableCell>{item.afxon}</TableCell>
              <TableCell>
                <Text>{item.katigoria}</Text>
              </TableCell>
              <TableCell>{item.eponymo}</TableCell>
              <TableCell>{item.onoma}</TableCell>
              <TableCell>{item.patronymo}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default Defendants;
